<div class="modal-dialog container">
  <div class="modal-content">
    <div class="modal-header">Generate upload link to {{ this.folder.name }}</div>

    <div class="modal-body cl-form">
      @if (ticket) {
        <app-cl-tabs>
          <app-cl-tab tab_title="Link">
            <p>Use <a class="cl-a cl-a-external" [href]="this.ticket?.url" target="_blank">this link</a> to upload files to the {{ this.folder.name }} folder</p>
            <div class="pre-container">
              <pre class="pre-wrap">{{ this.ticket?.url }}</pre>
              <button class="pre-copy-btn btn cl-btn-icon cl-color-tertiary" (click)="copyClipboard()"
                [attr.aria-label]="copied() === 'link' ? 'Link copied to clipboard' : 'Copy link to clipboard'">
                @if (copied() === 'link') {
                  <i class="fas fa-fw fa-check" aria-hidden="true"></i>
                } @else {
                  <i class="fas fa-fw fa-copy" aria-hidden="true"></i>
                }
              </button>
            </div>
          </app-cl-tab>
          <app-cl-tab tab_title="AWS CLI">
            <p>Use the following profile in your AWS CLI config file to access this folder:</p>
            <div class="pre-container">
              <pre style="padding-right: 48px;">{{ awsProfileText }}</pre>
              <button class="pre-copy-btn btn cl-btn-icon cl-color-tertiary" (click)="copyAwsProfile()"
                [attr.aria-label]="copied() === 'aws' ? 'Profile copied to clipboard' : 'Copy profile to clipboard'">
                @if (copied() === 'aws') {
                  <i class="fas fa-fw fa-check" aria-hidden="true"></i>
                } @else {
                  <i class="fas fa-fw fa-copy" aria-hidden="true"></i>
                }
              </button>
            </div>
          </app-cl-tab>
          <app-cl-tab tab_title="Cyberduck">
            <div style="display: flex; flex-direction: column; gap: 12px;">
              <p>To upload files to this folder via Cyberduck, follow these steps: </p>
              <ol class="cl-list cl-tight">
                <li>Download the bookmark</li>
                <li>Double-click to open in Cyberduck</li>
                <li>Click <strong>Skip</strong> when asked to sign in</li>
              </ol>

              <p class="alert cl-alert-info" role="alert">Link expires on <app-date [value]="ticket.expiration" />. Requires Cyberduck 9.3 or later.</p>
              <div class="cl-spacing-box">
                <button class="btn cl-color-primary" (click)="downloadCyberduckBookmark()">
                  Download Cyberduck Bookmark
                </button>
              </div>
            </div>
          </app-cl-tab>
          <app-cl-tab tab_title="Direct Upload">
            <iframe class="ul-embed" title="Direct upload" [attr.src]="this.ticket?.embedurl"></iframe>
          </app-cl-tab>
        </app-cl-tabs>
      }
      @if (!ticket) {
        <label for="message" class="form-label">Message for uploader</label>
        <textarea id="message" [(ngModel)]="message" rows="4" style="width: 100%"
          cdkTextareaAutosize
        ></textarea>
      }

    </div>
    <div class="modal-footer">
      <app-form-footer label="Generate link" (action)="genLink($event)" [showAction]="ticket === null">
        <button footerStart type="button" class="btn cl-color-secondary it-ok" (click)="dialogRef.close()"><span>Close</span></button>
      </app-form-footer>
    </div>
    </div>
  </div>
